import { render, staticRenderFns } from "./TrialCountdown.vue?vue&type=template&id=27cea6e4&scoped=true"
import script from "./TrialCountdown.vue?vue&type=script&lang=js"
export * from "./TrialCountdown.vue?vue&type=script&lang=js"
import style0 from "./TrialCountdown.vue?vue&type=style&index=0&id=27cea6e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cea6e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
